// extracted by mini-css-extract-plugin
export default {"cam":"styles_cam__cIXkK"};